import { commonFilter } from './filter';

export default {
  pageName: 'feedsGameStore',
  pageId: '20003',
  pagePath: '/opinion/gameStore',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    C_keyword: {
      buttonId: '200030',
    },
    GPT_Get_Btn: {
      buttonId: '2000301',
    },
    GPT_Confirm: {
      buttonId: '2000302',
    },
    ...commonFilter,
  },
};
